import { observer } from 'mobx-react-lite'
import React, { FormEvent, useEffect } from "react"
import { Titles } from "../../../../layouts/Titles";
import i from "../../../../translations/i";
import { Options } from '../../../../components/options/Options'
import OptionTypesController from "../../../../components/options/optionTypes.controller";
import OptionValuesController from "../../../../components/options/optionValues.controller";

export const PaymentOptionList = observer(() => {

  useEffect(() => {
    OptionTypesController.get(['paymentAfterAssembly'])
      .then((keys: string[]) => OptionValuesController.get(keys))
  }, [])

  const buttons = [
    { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
  ]

  return(
    <>
      <form onSubmit={(e: FormEvent) => OptionValuesController.save(e)}>
        <Titles
          title={i.t('paymentOptions:paymentSettings')}
          buttons={buttons}
        />

        {OptionTypesController.render && OptionValuesController.render && <Options key={`optionList`} types={OptionTypesController.items} options={OptionValuesController.items} />}
      </form>
    </>
  )
})

